"use client";

import { useEffect, useRef, useState } from "react";

type StickySidebarProps = {
  topClass: string;
  children: React.ReactNode;
};

export default function StickySidebar({ topClass, children }: StickySidebarProps) {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(!entry.isIntersecting),
      { threshold: 0 }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div ref={sentinelRef} className="h-px" />
      <div className={`sticky inline-block text-left transition-[padding] duration-200 ${topClass} ${isStuck ? "pt-10" : "pt-0"}`}>
        {children}
      </div>
    </>
  );
}
